<div id="addUser" class="subBlockContainer entry-loader">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="child-body">
      <div class="inner-subBlock-wrapper">
        <!-- <div class="page-title-wrapper">
          <div class="title blade-title-font">
            {{title}}
          </div>
          <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
        </div> -->
        <div [formGroup]="userFormGroup">
          <div class="userinfo" formGroupName="userGroup">
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="loginNameValidate" formControlName="loginName" placeholder="LOGIN NAME">
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="firstNameValidate" formControlName="firstName" placeholder="FIRST NAME">
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="lastNameValidate" formControlName="lastName" placeholder="LAST NAME">
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="emailValidate" formControlName="email" placeholder="EMAIL">
            </mat-form-field>
            <!-- <mat-form-field [floatLabel]="'always'">
              <input matInput class="passwordValidate" [type]="hide ? 'password' : 'text'" formControlName="password" pattern="[^' ']+"
                placeholder="PASSWORD">
              <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="confirmPasswordValidate" [type]="hideConfirm ? 'password' : 'text'" pattern="[^' ']+"
                formControlName="confirmPassword" placeholder="CONFIRM PASSWORD">
              <mat-icon matSuffix (click)="hideConfirm = !hideConfirm">
                {{hideConfirm ? 'visibility_off' : 'visibility'}}</mat-icon>
            </mat-form-field> -->
          </div>
        </div>
        <password [showOldPassword]="false" [showConfirmPassword]="true" 
        (isValidPassword)="checkIsValidPassoword($event);" (isPasswordMatch)="checkIsPasswordMatch($event)"
        (newPassword)="getNewPassword($event)"></password>
      

        <div class="page-title-wrapper">
          <div class="title blade-title-font">
            Access Level
          </div>
        </div>

        <mat-slide-toggle style="display: block" checked>View Access<div style="font-size:10px">Can view the
            website and is unable to complete transactions</div>
        </mat-slide-toggle>
        <mat-slide-toggle style="display: block" [(ngModel)]="purchaseChecked">Purchase Access<div style="font-size:10px">
            Can view and purchase products on behalf of this account</div>
        </mat-slide-toggle>
        <mat-slide-toggle style="display: block" [(ngModel)]="adminChecked">Admin Access<div style="font-size:10px">
            Can create and maintain user access</div>
        </mat-slide-toggle>
      </div>

      <div class="button-wrapper align-center margin-t-x80">
        <button class="button button-red button-large saveuser" (click)="saveUser()">Save</button>
      </div>
    </div>
  </div>

</div>
<router-outlet></router-outlet>